import {
  Component,
  computed,
  Inject,
  inject,
  linkedSignal,
  OnInit,
  signal,
  ChangeDetectionStrategy
} from '@angular/core';

import { FileInputComponent, IconComponent, MessageBarService, Modal, MultilineInputComponent } from '@softline/ui-core';
import { Bewe } from '../../types/bewegung';
import { ReklamationService } from '../../services/reklamations-service';
import { Reklamation, ReklamationGrund } from '../../types/reklamation';
import { PalettenInfo } from '../../types/paletten-info';
import {
  ArchiveFile,
  ArchiveStore,
  showRequestErrors,
  SOFTLINE_FEATURE_ARCHIVE,
} from '@softline/application';
import { SOFTLINE_SERVICE_UUID, Store } from '@softline/core';

import { SelectComponent, SelectOptionDirective, SelectOptionHeaderDirective, SelectOptionSeparatorDirective } from '@softline/ui-core/combo-box';
@Component({
  selector: 'soft-reklamation-dialog',
  imports: [
    IconComponent,
    SelectComponent,
    SelectOptionDirective,
    MultilineInputComponent,
    FileInputComponent
],
  templateUrl: './reklamation-dialog.component.html',
  styleUrl: './reklamation-dialog.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [ReklamationService] })
export class ReklamationDialogComponent implements Modal<Reklamation | null>, OnInit {
  readonly store = inject(Store);
  readonly messageBarService = inject(MessageBarService);
  readonly reklaService = inject(ReklamationService);
  private uuid = inject(SOFTLINE_SERVICE_UUID);

  readonly _idwu = signal<string | null>(null);
  readonly _bewe = signal<Bewe | null>(null);
  readonly openedReklamation = signal<Reklamation | null>(null);
  readonly reklaGruende = signal<ReklamationGrund[] | null>(null);
  readonly uploadedFiles = signal<File[] | null>(null);

  readonly reklaKommentar = computed(() => {
    const openedRekla = this.openedReklamation();

    if (!openedRekla?.beschreibungsText) return signal(null as unknown as string | null);

    return signal(openedRekla.beschreibungsText);
  });

  readonly selectedGrund = computed(() => {
    const openedRekla = this.openedReklamation();

    if (!openedRekla?.reklamationsgrundBean) return signal(this.reklaGruende()?.[0]);

    return signal(openedRekla.reklamationsgrundBean);
  });

  set idwu(idwu: string) {
    this._idwu.set(idwu);
  }

  set bewe(bewe: Bewe) {
    this._bewe.set(bewe);
  }

  async ngOnInit(): Promise<void> {
    const gruende = await this.reklaService.loadGruende();

    this.reklaGruende.set(gruende);

    const idReklamation = this._bewe()?.idReklamation;
    const beweId = this._bewe()?.id;
    if (!idReklamation || !beweId) return;

    const rekla = await this.reklaService.loadReklamation(beweId);
    this.openedReklamation.set(rekla);
  }

  async submit() {
    const uploadedFiles = this.uploadedFiles();
    const grund = this.selectedGrund()();
    const belegid = this._bewe()?.id;
    const reklamationsmenge = this._bewe()?.artikelMenge.menge ?? null;
    let archiveKey: null | string = null;
    let id: null | number = null;
    if (!grund || !belegid) return;

    const openedRekla = this.openedReklamation();

    if (openedRekla) {
      archiveKey = openedRekla.archiveKey;
      id = openedRekla.id;
    }

    const body: Reklamation = {
      reklamationsgrundBean: grund,
      beschreibungsText: this.reklaKommentar()() ?? '',
      belegtyp: 'bewewu',
      belegid: belegid,
      archiveKey,
      id,
      reklamationsmenge };

    console.log(body);

    try {
      const result = await this.reklaService.createReklamation(body);
      archiveKey = result.archiveKey;

      console.log('RESULT', result);

      if ((uploadedFiles?.length ?? 0) > 0 && uploadedFiles) {
        console.log('files: ', uploadedFiles);
        const succeeded: ArchiveFile[] = [];
        const failed: File[] = [];
        for (const file of uploadedFiles) {
          try {
            const token = this.uuid();
            const result = await this.store.dispatch(
              SOFTLINE_FEATURE_ARCHIVE,
              ArchiveStore.actions.upload,
              {
                archiveKey: archiveKey ?? '',
                files: [file],
                token }
            );
            succeeded.push(result);
          } catch (e) {
            failed.push(file);
          }
        }
        this.messageBarService.success(
          'Es wurden ' +
            succeeded.length +
            ' von ' +
            uploadedFiles.length +
            ' Dateien hochgeladen!'
        );
      }

      this.close(result);
    } catch (error) {
      showRequestErrors(this.store, error);
    }
  }

  close!: (result: Reklamation | null) => void;

  registerCloseHandler(handler: (result: Reklamation | null) => void): void {
    this.close = handler;
  }
}
